import { Controller } from '@hotwired/stimulus'
import { request } from '../lib/request'

export default class extends Controller {
  static values = {
    url: String,
    method: String,
    body: Object,
    useInputs: Boolean,
    preventDefault: { type: Boolean, default: true },
    confirmMessage: String,
    redirectUrl: String,
  }

  submit = (event) => {
    if (this.hasConfirmMessageValue) {
      if (!window.confirm(this.confirmMessageValue)) {
        event.preventDefault()
        event.stopImmediatePropagation()
        return
      }
    }

    if (this.preventDefaultValue) {
      event.preventDefault()
    }

    this.setBodyValue()

    request(this.methodValue || 'POST', this.urlValue, {
      body: this.bodyValue,
      responseKind: 'turbo-stream',
    })

    if (this.hasRedirectUrlValue) {
      window.location.href = this.redirectUrlValue
    }
  }

  setBodyValue() {
    if (this.useInputsValue) {
      this.bodyValue = this.bodyFromInputs
    }
  }

  get bodyFromInputs() {
    const body = this.bodyValue
    this.element.querySelectorAll('input').forEach((element) => {
      body[element.name] = element.value
    })

    return body
  }
}
